import * as z from 'zod';

export const GetEcommerceSettingsRequest = z.object({
  fields: z
    .array(
      z.enum([
        'ADDITIONAL_FEES_SERVICE_PLUGIN',
        'VALIDATIONS_SERVICE_PLUGIN',
        'TAX',
        'DISCOUNT_RULES',
        'CHECKOUT',
        'DELIVERY',
        'PREMIUM_SITE',
        'BUSINESS_INFO',
      ])
    )
    .min(1)
    .max(25),
});
export const GetEcommerceSettingsResponse = z.object({
  errors: z
    .array(
      z.object({
        requestedField: z
          .enum([
            'ADDITIONAL_FEES_SERVICE_PLUGIN',
            'VALIDATIONS_SERVICE_PLUGIN',
            'TAX',
            'DISCOUNT_RULES',
            'CHECKOUT',
            'DELIVERY',
            'PREMIUM_SITE',
            'BUSINESS_INFO',
          ])
          .describe('The requested field the error is related to.')
          .optional(),
      })
    )
    .optional(),
});
